import addonsAPI from '../../Data/Addons';
import strawAPI from '../../Data/Straws';
import * as actionTypes from './addon-types';

const getAddons = () => {
    return async dispatch => {
        const response = await addonsAPI.addonsList();
    
        if(response.hasOwnProperty('errorCode') && response.errorCode === 0) {
            dispatch(getAddonsSuccess(response.data)); 
        }
    }
}

const getAddonsSuccess = (data) => {
    return {
        type: actionTypes.ADDON_LIST,
        payload: {
            data
        }
    };
}

const getStraws = () => {
    return async dispatch => {
        const response = await strawAPI.strawsList();

        if( response.hasOwnProperty('errorCode') && response.errorCode === 0 ) {
            dispatch(getStrawsSuccess(response.data));
        }
    }
}

const getStrawsSuccess = (data) => {
    return {
        type: actionTypes.STRAW_LIST,
        payload: {
            data
        }
    }
}

const addonActions = {
    getAddons,
    getStraws,
}

export default addonActions;